module.exports = __webpack_public_path__ + "img/shop_btn.bd6e67e4.png";